module.exports = __webpack_public_path__ + "static/success.f7e44e6e.svg";